import React from 'react'
import {FaGithub,FaLinkedin} from "react-icons/fa"
import {HiOutlineMail} from "react-icons/hi"
const Contact = () => {
  return (
    <div name="Contact">

    <div
    className='w-full h-full bg-slate-800 text-slate-200 pt-40'
    >
        <div className='flex flex-col p-4 justify-center max-w-screen-lg 
        mx-auto h-full'>
            <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 border-amber-500 '>Contact</p>
                <p className='text-2xl flex justify-center items-center font-bold text-amber-500 mt-10'>Submit The Form Below To Get In Touch With Me</p>
            </div>
            <div className='flex justify-center items-center'>
                <form action="https://getform.io/f/408bcea8-d462-4453-a608-4b9983a5c0bb"
                method="POST"
                className='flex flex-col w-full md:w-1/2'
                >
                    <input type="text" name='name' placeholder='Enter Your Name'
                    className=" my-4 p-2 bg-transparent border-2 rounded-md
                    text-white focus:outline-none" required
                    />
                    <input type="text" name='email' placeholder='Enter Your Email'
                    className=" my-4 p-2 bg-transparent border-2 rounded-md
                    text-white focus:outline-none" required
                    />
                    <textarea name='message'
                    placeholder='Enter Your Message' 
                    rows="10"
                    className="p-2 bg-transparent border-2 rounded-md
                    text-white focus:outline-none" required
                    ></textarea>
                    <button className='text-white bg-gradient-to-b
                    from-cyan-500 to-blue-500 px-6 py-3 my-8
                    mx-auto flex justify-center items-center rounded-md 
                    hover:scale-110 duration-300' >Let's Talk</button>
                </form>
            </div>
            <div className='flex items-center justify-around h-10 w-2/3 md:w-1/3 mx-auto  text-slate-200' style={{cursor:'pointer'}}>
            <a href="https://www.linkedin.com/in/supriyo-samanta-a88939230/" target="_blank" rel="noreferrer"><FaLinkedin className=' hover:text-cyan-500 duration-300' size={30}/></a>
            <a href="mailto:supriyosamanta1997@gmail.com" target="_blank" rel="noreferrer"><HiOutlineMail className=' hover:text-cyan-500 duration-300' size={30}/></a>
            <a href="https://github.com/supriyosamanta1997" target="_blank" rel="noreferrer"><FaGithub className=' hover:text-cyan-500 duration-300' size={30}/></a>
            </div>
            <div className='text-xl h-14 w-full md:w-2/3 mx-auto text-center mt-5 text-slate-200' style={{cursor:'pointer'}} >
            <a href="mailto:supriyosamanta1997@gmail.com" target="_blank" rel="noreferrer">Email:<span className='text-cyan-500'>supriyosamanta1997@gmail.com</span></a>
            
            <p className=' text-xl'>Phone:<span className='text-cyan-500'>6291983229/8967399137</span></p>
            </div>
        </div>
    </div>
    </div>
  )
}

export default Contact